import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'

import InputElement from '../../utils/input'
import { apiResourceEndpoint } from '../../../constants/routes'
import Modal from '../../utils/modal'
import ExamplePhoto from './example-photo'

const mapStateToProps = (state, ownProps) => {
    const answer = state.answers.find(a => a.groupQuestionId === ownProps.groupQuestionId && a.installationId === ownProps.installation.id)
    let answerValue = null
    if (answer) {
        answerValue = state.answerValues
            .filter(av => av.answerId === answer.id)
            .sort((a, b) => b.id - a.id)[0] ?? null
    }
    let image = null
    if (answerValue) {
        image = state.images.find(img => img.id === answerValue.imageId)
    }
    return {
        answer,
        answerValue,
        image,
        examples: state.questionExamples.filter(example => example.questionId === ownProps.question.id)
    }
}

const ImageQuestion = ({ dispatch, question, answer, answerValue, image, installation, examples }) => {
    const [showModal, setShowModal] = useState(false)
    const [showExamples, setShowExamples] = useState(false)
    const [previewUrl, setPreviewUrl] = useState(null)

    useEffect(() => {
        return () => {
            if (previewUrl) {
                URL.revokeObjectURL(previewUrl)
            }
        }
    }, [previewUrl])

    const handleFileChange = (id, file) => {
        if (file) {
            setPreviewUrl(URL.createObjectURL(file))
        }
    }

    const renderNotes = () => {
        if (answerValue?._computed.statusValue === 'REJECTED') {
            return (
                <div className="rejected-notes">
                    <span className="error-label"> Error</span>
                    <p className="notes">
                        {answerValue.notes}
                    </p>
                </div>
            )
        }
        return null
    }

    let inputId = `answer_${answer?.id}`
    if (answerValue) {
        inputId = inputId + '_' + answerValue.id
    }

    const renderExamples = () => {
        if (examples.length === 0) {
            return null
        }
        return (
            <div className="image-examples">
                <span className="clickable" onClick={() => setShowExamples(!showExamples)}>
                    {showExamples ? 'Hide' : 'Show'} Example Photos
                </span>
                { showExamples &&
                    <div className="photos">
                        {examples.map(example => {
                            return <ExamplePhoto key={example.id} example={example} />
                        })}
                    </div>
                }
            </div>
        )
    }

    return (
        <>
            <InputElement
                accept="image/*"
                type="file"
                id={inputId}
                infoIcon={question?.instructions ? 'circle-info' : null}
                instructions={question?.instructions}
                extraClass={`with-status ${answer?._computed.statusValue.toLowerCase()}`}
                label={question.label}
                readOnly={installation?._computed.statusDisplay === 'Submitted' ? true : false}
                onChange={handleFileChange} />
            {(previewUrl || image) &&
                <div className="image-wrapper" onClick={() => setShowModal(true)}>
                    <img src={previewUrl || process.env.REACT_APP_API_URL + apiResourceEndpoint(`installations`, 'VIEW', installation.id, `image/${answer.id}`).url + `?style=thumbnail&iv=${image.id}`} alt="answer value" />
                </div>
            }
            {renderExamples()}
            {renderNotes()}
            {showModal &&
                <Modal closeAction={() => setShowModal(false)}>
                    <img src={previewUrl || process.env.REACT_APP_API_URL + apiResourceEndpoint(`installations`, 'VIEW', installation.id, `image/${answer.id}`).url + `?style=large&iv=${image.id}`} alt="answer value" />
                </Modal>
            }
        </>
    )
}

export default connect(mapStateToProps)(ImageQuestion)
